export const MIN_GOAL = 1;
export const MAX_GOAL = 20;
export const DEFAULT_GOAL = 5;

/**
 * At the top of the range the count is shown as "20+" to signal the cap is open-ended.
 */
export function formatGoal(value: number): number | string {
	return value >= MAX_GOAL ? `${value}+` : value;
}
